import createIcon from '../../createIcon';

/**
 * @component @name EnhancedEncryption
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggOC41SDE3VjYuNUMxNyAzLjc0IDE0Ljc2IDEuNSAxMiAxLjVDOS4yNCAxLjUgNyAzLjc0IDcgNi41VjguNUg2QzQuOSA4LjUgNCA5LjQgNCAxMC41VjIwLjVDNCAyMS42IDQuOSAyMi41IDYgMjIuNUgxOEMxOS4xIDIyLjUgMjAgMjEuNiAyMCAyMC41VjEwLjVDMjAgOS40IDE5LjEgOC41IDE4IDguNVpNOC45IDYuNUM4LjkgNC43OSAxMC4yOSAzLjQgMTIgMy40QzEzLjcxIDMuNCAxNS4xIDQuNzkgMTUuMSA2LjVWOC41SDguOVY2LjVaTTE2IDE2LjVIMTNWMTkuNUgxMVYxNi41SDhWMTQuNUgxMVYxMS41SDEzVjE0LjVIMTZWMTYuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EnhancedEncryption = createIcon('EnhancedEncryption', [
  [
    'path',
    {
      d: 'M18 8.5H17V6.5C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5V8.5H6C4.9 8.5 4 9.4 4 10.5V20.5C4 21.6 4.9 22.5 6 22.5H18C19.1 22.5 20 21.6 20 20.5V10.5C20 9.4 19.1 8.5 18 8.5ZM8.9 6.5C8.9 4.79 10.29 3.4 12 3.4C13.71 3.4 15.1 4.79 15.1 6.5V8.5H8.9V6.5ZM16 16.5H13V19.5H11V16.5H8V14.5H11V11.5H13V14.5H16V16.5Z',
      key: '1x4iqk',
    },
  ],
]);

export default EnhancedEncryption;
